module.exports = __webpack_public_path__ + "img/logo.6c7e2cd1.png";